<script>
  import { quintOut } from "svelte/easing";
  import { slide } from "svelte/transition";
  export let message, show;
</script>

{#if show}
  <div
    on:click={() => (show = false)}
    class="alert alert-warning align-items-center"
    role="alert"
    transition:slide={{ duration: 1000, easing: quintOut }}
  >
    <div>{message}</div>
  </div>
{/if}
